module.exports = __webpack_public_path__ + "media/images/tick-a2d415b49ee1a7c726c1acb674a64820.svg";